/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {ErrorComponent} from "./platform/error/error.component";

const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./aigia/aigia.module').then((m) => {
			return m.AigiaModule;
		})
	},
	{
		path: 'blog',
		loadChildren: () => import('./news/news.module').then((m) => {
			return m.NewsModule;
		})
	},
	{
		path: 'platform',
		loadChildren: () => import('./platform/platform.module').then((m) => {
			return m.PlatformModule;
		})
	},
	{path: '**', component: ErrorComponent},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})

export class AppRoutingModule {
}
